<div>
  <div class="toc-sidebar" [class.collapsed]="!isTocVisible">
    <div
      class="sidebar-header"
      [ngClass]="isTocVisible ? 'justify-content-between' : 'justify-content-center'"
    >
      <div *ngIf="isTocVisible">Table of contents</div>
      <button (click)="toggleToc()" class="toggle-toc-btn">
        <span *ngIf="isTocVisible">←</span>
        <span *ngIf="!isTocVisible">→</span>
      </button>
    </div>
    <div *ngIf="!isTocVisible" class="vertical-text">Table of Contents</div>
    <div class="sidebar-content" *ngIf="isTocVisible">
      <ngb-accordion class="table-of-contents mainNgbAccordion" [closeOthers]="true">
        <ng-container *ngFor="let section of tocSections; let index = index">
          <ngb-panel *ngIf="isCustomReport || section.flag" id="toc-panel-{{ index }}">
            <ng-template ngbPanelTitle>
              <div class="sidebar-toc-header">
                <p class="sidebar-toc-heading">
                  <a (click)="scrollToElement(section.id)" title="{{ section.title }}">{{
                    section.title
                  }}</a>
                </p>
              </div>
            </ng-template>
            <ng-template ngbPanelContent>
              <div *ngIf="section.children && section.children.length > 0">
                <div *ngFor="let child of section.children">
                  <p
                    class="sidebar-toc-subheader"
                    *ngIf="
                      isCustomReport ||
                      (reportAccessData &&
                        (reportAccessData[section.dataKey] | sectionFilter : child.filter))
                    "
                  >
                    <a (click)="scrollToElement(child.id)" title="{{ child.title }}">{{
                      child.title
                    }}</a>
                  </p>
                </div>
              </div>
            </ng-template>
          </ngb-panel>
        </ng-container>
      </ngb-accordion>
    </div>
  </div>
</div>
